export function mapValues<K extends string, V, R>(
  object: Record<K, V>,
  mapFn: (v: V) => R
): Record<K, R> {
  return Object.fromEntries(
    Object.entries(object).map(([k, v]: [K, V]): [K, R] => [k, mapFn(v)])
  ) as Record<K, R>
}
